



















































import { Component, Vue } from 'vue-property-decorator'
import Timer from '@/components/common/Timer.vue'
import HighlightText from '@/components/HighlightText.vue'
import Modal from '@/components/common/Modal.vue'
import { bus } from '@/components/common/Chat.vue'

@Component({
  components: {
    Timer,
    HighlightText,
    Modal
  }
})
export default class ScreenOne extends Vue {
  private timerDurationInSeconds = 60 * 10 // 10min
  private isEnd = false
  private isTimerResetConfirmationModalOpen = false
  private unwatchTimerFinished: (() => void) | null = null

  private mounted (): void {
    bus.$emit('PAGE_LOADED')

    if ((window.location.host.includes('localhost')) || window.location.host.includes('dev.events.bella.health')) {
      this.timerDurationInSeconds = 60
    }
    this.isEnd = this.$store.getters['timer/finished']
    this.unwatchTimerFinished = this
      .$store
      .watch(
        (state, getters) => getters['timer/finished'],
        (timerFinished) => {
          this.isEnd = timerFinished
        },
        { immediate: true }
      )
    this.$store.dispatch('timer/disableTimerBar')
    this.$store.dispatch('timer/start', { sourceLocation: { name: 'quidel 4' }, durationInSeconds: this.timerDurationInSeconds })
  }

  private resetTimer ():void {
    this.$store.dispatch('timer/restart')
    this.isTimerResetConfirmationModalOpen = false
  }

  private onlyDesktop (): boolean {
    return window.innerWidth > this.$data.mobileWidth
  }

  private goTo (): void {
    if (this.$store.getters['timer/finished'] && this.$store.getters['timer/sourceLocation']?.name === this.$route.name) {
      this.$store.dispatch('timer/clear')
        .then(() => {
          this.goToNext()
        })
    }
    this.goToNext()
  }

  private goToNext ():void {
    this.$router.push('/quidel/5')
  }

  private destroyed (): void {
    if (this.unwatchTimerFinished) this.unwatchTimerFinished()
    this.$store.dispatch('timer/enableTimerBar')
  }
}
